"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview21_exports = {};
__export(GeodesPreview21_exports, {
  default: () => GeodesPreview21_default
});
module.exports = __toCommonJS(GeodesPreview21_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.7148 3.21875C15.806 3.14062 15.832 3.04948 15.793 2.94531C15.7669 2.82812 15.6953 2.76302 15.5781 2.75C15.3307 2.73698 15.0833 2.75651 14.8359 2.80859C14.5885 2.84766 14.3542 2.89323 14.1328 2.94531C13.8333 3.02344 13.5534 3.14714 13.293 3.31641C13.0326 3.47266 12.7982 3.66797 12.5898 3.90234C12.3945 4.13672 12.2318 4.39714 12.1016 4.68359C11.9844 4.95703 11.9062 5.25 11.8672 5.5625C11.8411 5.86198 11.8542 6.16146 11.9062 6.46094C11.9714 6.76042 12.0755 7.04688 12.2188 7.32031L3.42969 15.9727C3.26042 16.1419 3.17578 16.3438 3.17578 16.5781C3.17578 16.8125 3.26042 17.0143 3.42969 17.1836C3.61198 17.3529 3.82031 17.4375 4.05469 17.4375C4.30208 17.4375 4.51042 17.3529 4.67969 17.1836L13.4688 8.53125C13.7422 8.6875 14.0286 8.79818 14.3281 8.86328C14.6406 8.91536 14.9466 8.92188 15.2461 8.88281C15.5586 8.85677 15.8581 8.78516 16.1445 8.66797C16.431 8.53776 16.6914 8.375 16.9258 8.17969C17.1602 7.97135 17.362 7.74349 17.5312 7.49609C17.7005 7.23568 17.8242 6.95573 17.9023 6.65625C17.9544 6.46094 17.987 6.25911 18 6.05078C18.013 5.84245 18 5.63411 17.9609 5.42578C17.9479 5.29557 17.8763 5.21745 17.7461 5.19141C17.6159 5.15234 17.4987 5.1849 17.3945 5.28906L15.8516 6.79297C15.7995 6.85807 15.7344 6.91667 15.6562 6.96875C15.5911 7.00781 15.513 7.04688 15.4219 7.08594C15.3438 7.125 15.2591 7.15104 15.168 7.16406C15.0898 7.17708 15.0052 7.18359 14.9141 7.18359C14.8359 7.18359 14.7513 7.17708 14.6602 7.16406C14.569 7.15104 14.4844 7.125 14.4062 7.08594C14.3281 7.0599 14.25 7.02734 14.1719 6.98828C14.1068 6.9362 14.0417 6.8776 13.9766 6.8125C13.9115 6.7474 13.8529 6.68229 13.8008 6.61719C13.7617 6.53906 13.7227 6.46094 13.6836 6.38281C13.6576 6.30469 13.6315 6.22656 13.6055 6.14844C13.5924 6.05729 13.5859 5.96615 13.5859 5.875C13.5859 5.79688 13.5924 5.71875 13.6055 5.64062C13.6315 5.54948 13.6641 5.46484 13.7031 5.38672C13.7292 5.30859 13.7682 5.23698 13.8203 5.17188C13.8724 5.09375 13.931 5.02214 13.9961 4.95703L15.7148 3.21875ZM6.84766 4.66406L4.5625 3.39453C4.40625 3.31641 4.24349 3.29036 4.07422 3.31641C3.91797 3.34245 3.77474 3.41406 3.64453 3.53125L3.21484 3.94141C3.09766 4.07161 3.02604 4.22135 3 4.39062C2.98698 4.54688 3.01953 4.69661 3.09766 4.83984L4.36719 7.10547L5.92969 7.39844L8.01953 9.60547L9.25 8.375L7.16016 6.1875L6.84766 4.66406ZM12.375 11.4805L11.125 12.6914L16.1641 17.4961C16.2422 17.5742 16.3333 17.6393 16.4375 17.6914C16.5417 17.7305 16.6523 17.75 16.7695 17.75C16.8737 17.75 16.9779 17.7305 17.082 17.6914C17.1992 17.6523 17.2969 17.6003 17.375 17.5352C17.4531 17.457 17.5182 17.3724 17.5703 17.2812C17.6224 17.1771 17.6549 17.0729 17.668 16.9688C17.681 16.8516 17.668 16.7409 17.6289 16.6367C17.6029 16.5326 17.5508 16.4349 17.4727 16.3438L17.4141 16.2656L12.375 11.4805Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview21 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview21_default = SvgGeodesPreview21;
